<template>
  <div class="change_group_dialog">
    <el-dialog
      title="调组"
      :visible.sync="openDialog"
      width="40%"
      class="dialog_title"
      @close="closeDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" size="small" label-width="150px">
        <el-form-item label="调到小组：" prop="group_id">
          <el-select
            v-model="form.group_id"
            placeholder="请选择调到小组"
            clearable
            :style="{ width: '50%' }"
          >
            <el-option
              v-for="(item, index) in group_idOptions"
              :key="index"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>

          <el-button
            type="primary"
            @click="handleCreateGroup()"
            style="margin-left: 10px"
            size="mini"
          >
            还未创建小组？进行小组设置吧
          </el-button>
        </el-form-item>
        <el-form-item label="是否设为该组组长：" prop="is_group_leader">
          <el-radio-group v-model="form.is_group_leader" size="medium">
            <el-radio
              v-for="(item, index) in is_group_leaderOptions"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        <el-button @click="cancel" size="small">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 创建小组 -->
    <el-dialog
      title="创建小组"
      :visible.sync="openDialog2"
      width="40%"
      class="dialog_title"
      @close="closeDialog2"
    >
      <el-form
        ref="groupForm"
        :model="groupForm"
        :rules="groupRules"
        size="small"
        label-width="150px"
      >
        <el-form-item label="未分组："> {{ noAllocation }}人 </el-form-item>

        <div v-for="(item, index) in setList" :key="index">
          <el-form-item label="小组名称：" prop="groupTitle">
            <div v-if="groupId == item.id" key="group-one">
              <el-input
                v-model="groupForm.groupTitle"
                placeholder="请输入名称"
                :style="{ width: '78%', marginRight: '10px' }"
                clearable
              />
              <span>
                <el-button
                  size="mini"
                  type="text"
                  style="padding: 0"
                  @click="handleGroupUpdate(item.id)"
                  >保存小组</el-button
                >
                <el-button size="mini" style="padding: 0" type="text" @click="GroupCancel"
                  >取消</el-button
                >
              </span>
            </div>
            <div v-else class="flex_X">
              <el-tooltip placement="top" effect="light">
                <div slot="content">{{ item.title }}（{{ item.user_number }}人）</div>
                <div
                  style="display: inline-block"
                  :style="{ maxWidth: '78%' }"
                  class="ellipsis"
                >
                  {{ item.title }}（{{ item.user_number }}人）
                </div>
              </el-tooltip>
              <span>
                <el-button
                  style="padding: 0"
                  size="mini"
                  type="text"
                  @click="handleGroupSet(item)"
                  >修改</el-button
                >
                <el-button
                  style="padding: 0"
                  size="mini"
                  type="text"
                  @click="handleDelete(item)"
                  >删除</el-button
                >
              </span>
            </div>
          </el-form-item>
        </div>

        <!-- <el-form-item label="+添加小组：" prop="workLabel">
          <div>
            <el-button
              type="primary"
              @click="workLabelShow = !workLabelShow"
              size="mini"
            >
              <span v-if="!workLabelShow">新增</span><span v-else>取消</span>
            </el-button>
          </div>
          <div v-if="workLabelShow">
            <el-input
              v-model="groupForm.workLabel"
              placeholder="请输入小组名称"
              :style="{ width: '50%' }"
            />
            <el-button
              type="success"
              @click="workLabelSubmit"
              style="margin-left: 10px"
              size="mini"
              >保存小组</el-button
            >
          </div>
        </el-form-item> -->
        <el-form-item label="+添加小组：">
          <el-button
            type="primary"
            @click="addGroup()"
            size="mini"
          >
            新增
          </el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelGroup" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增小组"
      :visible.sync="addGroupOpenDialog"
      width="40%"
      @close="addGroupCloseDialog"
      class="dialog_title"
    >
      <el-form
        ref="addGroupForm"
        :model="addGroupForm"
        :rules="addGroupRules"
        size="small"
        label-width="100px"
      >
        <el-form-item label="小组名称：" prop="title">
          <el-input
            v-model="addGroupForm.title"
            placeholder="请输入小组名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="小组成员：">
          <el-input
            v-model="memberListFilter.keyword"
            placeholder="搜索成员"
            clearable
            @input="getGroupMemberList()"
          />
        </el-form-item>
      </el-form>

      <el-table
        :data="memberList"
        stripe
        height="400"
        style="width: 100%"
        @selection-change="memberSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="truename"
          label="姓名"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="sexy_name"
          label="性别"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tel"
          label="手机号"
        >
        </el-table-column>
        <el-table-column
          label="是否组长"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column> -->
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addGroupSubmitForm" size="small">
          创建小组
        </el-button>
        <el-button @click="addGroupCancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBelongRroup,
  StudentChangeGroup,
  SetGroupList,
  UpdateClassGroup,
  DelClassGroup,
  AddcClassGroup,
  getApiGroupMemberList,
  postApiCreateGroup,
} from "@/api/tearcher";
export default {
  props: {
    class_id: {
      type: Number,
    },
  },
  data() {
    return {
      openDialog: false,
      openDialog2: false,
      form: {},
      groupForm: {
        workLabel: "",
      },
      id: "",
      group_id: "",
      noAllocation: "",
      //   class_id: "",
      groupId: 0,
      group_idOptions: [], // 获取隶属小组列表
      setList: [], // 获取设置小组列表
      is_group_leaderOptions: [
        { label: "是", value: 1 },
        { label: "否", value: 2 },
      ],
      // 表单校验
      rules: {
        group_id: [
          {
            required: true,
            message: "请选择调到小组",
            trigger: "change",
          },
        ],
        is_group_leader: [
          {
            required: true,
            message: "是否设为该组组长不能为空",
            trigger: "change",
          },
        ],
      },
      groupRules: {
        groupTitle: [
          {
            required: true,
            message: "请输入小组名称",
            trigger: "blur",
          },
        ],
        // workLabel: [
        //   {
        //     required: true,
        //     message: "请输入小组名称",
        //     trigger: "blur",
        //   },
        // ],
      },
      workLabelShow: false,
      addGroupOpenDialog: false, //创建小组弹窗是否显示
      //创建小组数据
      addGroupForm: {
        title: "",
        class_user_ids: "",
        class_id: this.class_id,
      },
      //创建小组表单验证
      addGroupRules: {
        title: [
          {
            required: true,
            message: "请输入小组名称",
            trigger: "blur",
          },
        ],
      },
      memberList: [], //小组人员列表
      //小组人员数据
      memberListFilter: {
        keyword: "",
        class_id: this.class_id,
        limit: 99999,
        page: 1
      }
    };
  },
  methods: {
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id;
      this.$confirm('是否确认删除"' + row.title + '"?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(function () {
          return DelClassGroup({ id: ids });
        })
        .then(() => {
          //   this.$emit("getList");
          //   this.GroupCancel();
          //   this.getSetList();
          //   this.msgSuccess("删除成功");
          this.messageTips("删除成功", "success");
          this.GroupCancel();
          this.SetGroupListFn();
        })
        .catch(function () {});
    },
    // 修改
    handleGroupSet(data) {
      this.groupId = data.id;
      this.$set(this.groupForm, "groupTitle", data.title);
    },
    // 取消按钮
    cancelGroup() {
      this.openDialog2 = false;
    },
    // 新增 小组操作
    workLabelSubmit() {
      if (this.groupForm.workLabel == "") {
        this.messageTips("小组名称不能为空", "error");
        return;
      }
      let group = {};
      group.class_id = this.class_id;
      group.title = this.groupForm.workLabel;
      AddcClassGroup(group)
        .then((response) => {
          if (response.error_code === 201) {
            this.messageTips("新增成功", "success");
            this.workLabelShow = false;
            this.groupForm.workLabel = "";
            this.SetGroupListFn();
          }
        })
        .catch((reason) => {
          this.messageTips("新增失败", "error");
        });
    },
    // 保存小组
    handleGroupUpdate(id) {
      this.$refs["groupForm"].validate((valid) => {
        if (valid) {
          if (this.groupId > 0) {
            UpdateClassGroup({
              class_id: this.class_id,
              title: this.groupForm.groupTitle,
              id: id,
            })
              .then((response) => {
                if (response.error_code === 201) {
                  this.messageTips("修改成功", "success");
                  this.workLabelShow = false;
                  //   this.workLabel = "";
                  this.GroupCancel();
                  this.SetGroupListFn();
                }
              })
              .catch((reason) => {
                this.messageTips("修改失败", "error");
              });
          }
        }
      });
    },
    // 取消保存
    GroupCancel() {
      this.groupId = 0;
      this.groupForm = {};
      this.resetForm("groupForm");
      // this.groupTitle = '';
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.id = this.id;
          StudentChangeGroup(this.form)
            .then((response) => {
              if (response.error_code === 201) {
                this.messageTips("调组成功", "success");
                this.openDialog = false;
                this.$emit("requestCommonFn");
              }
            })
            .catch((reason) => {
              console.log(reason);
            });
        }
      });
    },
    // 取消按钮
    cancel() {
      this.openDialog = false;
    },
    // 创建小组
    handleCreateGroup() {
      //   this.getSetList();
      //   this.titleGroup = "小组设置";
      this.openDialog2 = true;
      //
      //   this.class_id = class_id;
      // 获取设置小组列表
      this.SetGroupListFn();
    },
    // 获取设置小组列表
    SetGroupListFn() {
      SetGroupList({ class_id: this.class_id }).then((res) => {
        this.setList = res.data.list;
        this.noAllocation = res.data.no_allocation;
      });
    },
    // 关闭dialog
    closeDialog() {
      this.form = {};
      // 重置表单
      this.resetForm("form");
    },
    // 关闭dialog
    closeDialog2() {
      this.groupForm.workLabel = "";
      this.workLabelShow = false;
      // 重置表单
      //this.resetForm("groupForm");
      this.GroupCancel();
    },
    addGroupCloseDialog() {
      // this.groupForm.workLabel = "";
      // this.workLabelShow = false;
    },
    // 操作dialog
    operationDialog(id, group_id) {
      this.openDialog = true;
      this.id = id;
      this.group_id = group_id;
      //   this.class_id = class_id;
      // 获取隶属小组列表
      getBelongRroup({
        class_id: this.class_id,
      }).then((res) => {
        this.group_idOptions = res.data;
      });
      // 显示组
      this.$set(this.form, "group_id", group_id);
    },
    //创建小组
    addGroupSubmitForm() {
      this.$refs["addGroupForm"].validate((valid) => {
        if (valid) {
          if (this.addGroupForm.class_user_ids == "") {
            this.$message({
              message: '请选择小组成员',
              type: 'warning'
            });
            return false;
          }
          postApiCreateGroup(this.addGroupForm).then((res) => {
            this.SetGroupListFn();
            this.addGroupCancel();
          });
        }
      });
    },
    //打开创建小组弹窗
    addGroup() {
      this.addGroupOpenDialog = true;
      this.getGroupMemberList();
    },
    //关闭创建小组弹窗
    addGroupCancel() {
      this.addGroupOpenDialog = false;
    },
    //获取小组人员列表
    getGroupMemberList() {
      getApiGroupMemberList(this.memberListFilter).then((res) => {
        this.memberList = res.data.data;
      });
    },
    //小组人员选择回调
    memberSelectionChange(list) {
      if (list.length > 0) {
        let class_user_ids = [];
        list.forEach((item) => {
          class_user_ids.push(item.id);
        });
        this.addGroupForm.class_user_ids = class_user_ids.join(",");
      } else {
        this.addGroupForm.class_user_ids = "";
      }
    }
  },
};
</script>

<style lang="less" scoped>
.change_group_dialog {
  /deep/ .el-form {
    .el-input__inner {
      width: 100% !important;
    }
  }
}
</style>
